<template>
  <div class="main">
    <!--主页顶部-->
    <div class="mainHeader">
      <!--左侧logo-->
      <div class="mainHeaderLeft">
        <img src="../assets/image/logo.png" alt="">&nbsp;&nbsp;
        <span>能耗内网数据上传系统</span>
      </div>
      <!--菜单-->
     <div class="minHeaderCenter">
       <div class="topMenu">
         <el-menu
           :default-active="activeIndex"
           class="el-menu--horizontal"
           @select="handleSelect"
           text-color="#ffffff"
           active-text-color="#F39800">
           <el-menu-item index="statisticalInfoMain" v-permissions="permissionMap['statistics'].view">
             <div style="height: 14px">
               <img src="../assets/image/top_icon_data_sel.png" v-if="activeIndex == 'statisticalInfoMain'"/>
               <img src="../assets/image/top_icon_data_nor.png" v-else/>
             </div>
             <span slot="title">全厂看版</span>
           </el-menu-item>
           <el-menu-item index="demandRecordMain" v-permissions="permissionMap['demand'].view">
             <div style="height: 14px">
               <img src="../assets/image/top_icon_video_sel.png" v-if="activeIndex == 'demandRecordMain'"/>
               <img src="../assets/image/top_icon_video_nor.png" v-else/>
             </div>
             <span slot="title">数据分析</span>
           </el-menu-item>
           <el-menu-item index="contentManagement" v-permissions="permissionMap['content'].view">
             <div style="height: 14px">
               <img src="../assets/image/top_icon_device_sel.png" v-if="activeIndex == 'contentManagement'"/>
               <img src="../assets/image/top_icon_device_nor.png" v-else/>
             </div>
             <span slot="title">历史数据</span>
           </el-menu-item>
           <el-menu-item index="caseManagementMain" v-permissions="permissionMap['instance'].view">
             <div style="height: 14px">
               <img src="../assets/image/top_icon_alarm_sel.png" v-if="activeIndex == 'caseManagementMain'"/>
               <img src="../assets/image/top_icon_alarm_nor.png" v-else/>
             </div>
             <span slot="title">数据上传</span>
           </el-menu-item>
           <el-menu-item index="customerMessage" v-permissions="permissionMap['online'].view">
             <div style="height: 14px;">
               <img src="../assets/image/top_icon_set_sel.png" v-if=" activeIndex == 'customerMessage'||activeIndex == 'customerRepair'"/>
               <img src="../assets/image/top_icon_set_nor.png" v-else/>
             </div>
             <span slot="title">配置管理</span>
           </el-menu-item>
<!--           <el-menu-item index="schemeConfig" v-permissions="permissionMap['information'].view">-->
<!--             <img src="../assets/image/icon/icon_mail_sel.png" v-if="activeIndex == 'schemeConfig'"/>-->
<!--             <img src="../assets/image/icon/icon_mail_nor.png" v-else/>-->
<!--             <span slot="title">信息管理</span>-->
<!--           </el-menu-item>-->
<!--           <el-menu-item index="CustomerManage" v-permissions="permissionMap['user'].view">-->
<!--             <img src="../assets/image/icon/icon_user_sel.png" v-if="activeIndex == 'CustomerManage' || activeIndex =='staffMemberManage'"/>-->
<!--             <img src="../assets/image/icon/icon_user_nor.png" v-else/>-->
<!--             <span slot="title">用户管理</span>-->
<!--           </el-menu-item>-->
<!--           <el-menu-item index="personalData" v-permissions="permissionMap['personal'].view">-->
<!--             <img src="../assets/image/icon/icon_user_sel.png" v-if="activeIndex == 'personalData'"/>-->
<!--             <img src="../assets/image/icon/icon_user_nor.png" v-else/>-->
<!--             <span slot="title">个人资料</span>-->
<!--           </el-menu-item>-->
         </el-menu>
       </div>
     </div>
      <!--右侧设置以及用户名称-->
      <div class="minHeaderRight">
        <div class="headerUserInfo" style="width: 132px;margin-right: 40px">
        {{systemTime}}
        </div>
        <div class="headerUserInfo">
          <img src="../assets/image/icon/header_img_man.png" alt=""/>
<!--          <span>{{currentUserName}}</span>-->
          <el-dropdown @command="handleCommand" style="color: #fff">
            <div style="display: flex;cursor: pointer">
              <span>{{currentUserName}}</span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="changePs">修改密码</el-dropdown-item>
                <el-dropdown-item command="loginOut">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </div>
          </el-dropdown>
        </div>
<!--        <div class="setOut" @click="getLogout">-->
<!--          <i></i>-->
<!--          <p>退出登录</p>-->
<!--        </div>-->
      </div>
    </div>
    <!--主页内容-->
    <div class="wrap">
      <div class="rightContentScroll">
        <div class="rightContent">
          <router-view ref="routerview" v-on:updateCurrentUserInfo="updateCurrentUserInfo"></router-view>
        </div>
      </div>
    </div>
    <!--webSocket组件-->
    <web-socket :on-message="getMessage" :pageType="1" style="display:none;"></web-socket>
    <!--消息弹框-->
    <div class="pushInfoTipPop">
      <div class="tipContent"
           :class="{messageTipCon:item.type === 'message',repairTipCon:item.type === 'repair'}"
           v-for="item in pushInfoList"
          v-if="item.count != 0"
          @click="handleTip(item)">
        <i></i>
        <p>您有{{item.count}}份{{item.typeName}}待处理</p>
      </div>
    </div>
    <!--修改弹窗-->
    <div class="popBackground" v-show="showPsPop">
      <div class="popContent revisePop">
        <div class="popContentTop">
          <span>修改密码</span>
          <i  class="el-icon-close" @click="closePop()"></i>
        </div>
        <div class="popContentCon">
          <div style="margin-top: 0">
            <div style="margin-bottom: 8px">旧密码</div>
            <el-input show-password v-model="passwordInfo.oldPassword" style="width: 410px;"></el-input>
            <p class="tip" v-show="passwordInfo.showOldTip">请输入至少六位旧密码</p>
          </div>
          <div style="margin-top: 16px">
            <div style="margin-bottom: 8px">新密码</div>
            <el-input show-password v-model="passwordInfo.newPassword" style="width: 410px;"></el-input>
            <p class="tip" v-show="passwordInfo.showNewTip">请输入至少六位新密码</p>
          </div>
          <div style="margin-top: 16px">
            <div style="margin-bottom: 8px">确认密码</div>
            <el-input show-password v-model="passwordInfo.confirmPassword" style="width: 410px;"></el-input>
            <p class="tip" v-show="passwordInfo.showConfirmTip">请再次输入密码，并保持密码一致</p>
          </div>
        </div>
        <div class="popFooter">
          <button class="resetBtn" @click.prevent="closePop()">取消</button>
          <button class="saveBtn" @click.prevent="saveClick()">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import {parentRouteStack,dateToString} from "../assets/js/reusableFunctions";
  import {permissionMap} from "../assets/js/constant";
  import {originconfig} from "../../static/apiConfig/originConfig";
  import { MessageBox } from 'element-ui';
  import webSocket from "../components/websocket/websocket";
  export default {
    components: {webSocket},
    name: "basalPage",
    data() {
      return {
        systemTime:null,
        showPsPop:false,
        passwordInfo:{
          oldPassword: null,
          newPassword:null,
          confirmPassword: null,
          showOldTip:false,
          showNewTip:false,
          showConfirmTip:false
        },
        permission: '',
        rootRoute: '',
        currentRouteName:'',
        currentUser:{},
        currentUserName: '',
        userImg:'',
        activeIndex:'', //当前激活路由
        permissionMap: permissionMap,
        pushInfoList:[ // 推送消息列表
          {
            type:'repair',
            typeName:'报修',
            count:0
          },
          {
            type:'message',
            typeName:'留言',
            count:0
          },
        ]
      }
    },
    created(){
      this.showCurrentRootRoute();
    },
    mounted() {
      this.systemTime = dateToString(new Date().getTime(),6);
      setInterval(()=>{
        this.systemTime = dateToString(new Date().getTime(),6);
      },1000);
      let arr = this.$route.path.split('/');
      this.activeIndex = arr[arr.length - 1];
      if(arr[arr.length - 1] == 'staffMemberManage'){
        this.activeIndex = 'CustomerManage';
      }
      if(arr[arr.length - 1] == 'customerRepair'){
        this.activeIndex = 'customerMessage';
      }
      if(arr[arr.length - 1] == 'serviceManage'){
        this.activeIndex = 'bannerManage';
      }
      this.updateCurrentUserInfo();
      if(sessionStorage.getItem("pushInfoList") != null){
        let pushInfoList = JSON.parse(sessionStorage.getItem("pushInfoList"));
        if(this.$route.name == 'customerRepair'){
          this.pushInfoList = pushInfoList;
          this.$set(this.pushInfoList[1],'count',pushInfoList[1].count);
        }else if(this.$route.name == 'customerMessage'){
          this.pushInfoList = pushInfoList;
          this.$set(this.pushInfoList[0],'count',pushInfoList[0].count);
        }else {
          this.pushInfoList = pushInfoList;
        }
      }
    },
    watch: {
      $route(to,from){
        // this.activeIndex = to.name;
        this.showCurrentRootRoute();
        if(to.name == 'statisticalInfoMain'){
          this.activeIndex = 'statisticalInfoMain';
        }
        if(to.name == 'demandRecordMain'){
          this.activeIndex = 'demandRecordMain';
        }
        if(to.name == 'contentManagemente'){
          this.activeIndex = 'contentManagement';
        }
        if(to.name == 'caseManagementMain'){
          this.activeIndex = 'caseManagementMain';
        }
        if(to.name == 'staffMemberManage'||to.name == 'CustomerManage'){
          this.activeIndex = 'CustomerManage';
        }
        if(to.name == 'customerMessage'){
          this.activeIndex = 'customerMessage';
          this.$set(this.pushInfoList[1],'count',0);
          sessionStorage.setItem('pushInfoList', JSON.stringify(this.pushInfoList));
        }
        if(to.name == 'customerRepair'){
          this.activeIndex = 'customerMessage';
          this.$set(this.pushInfoList[0],'count',0);
          sessionStorage.setItem('pushInfoList', JSON.stringify(this.pushInfoList));
        }
        if(to.name == 'schemeConfig'){
          this.activeIndex = 'schemeConfig';
        }
      },
    },
    methods: {
      //下拉菜单点击事件
      handleCommand(command){
        //this.$message('click on item ' + command);
        if (command === 'loginOut'){
          this.getLogout()
        }else if (command === 'changePs'){
          //修改密码
          this.showPsPop = true
        }
      },
      // 关闭详情弹窗
      closePop(){
        this.showPsPop = false;
      },
      // 确认保修
      saveClick(){
        if(this.passwordInfo.oldPassword === null || this.passwordInfo.oldPassword.length<6){
          this.passwordInfo.showOldTip = true
          return
        }else{
          this.passwordInfo.showOldTip = false
        }
        if(this.passwordInfo.newPassword === null  || this.passwordInfo.newPassword.length<6){
          this.passwordInfo.showNewTip = true
          return;
        }else {
          this.passwordInfo.showNewTip = false
        }
        if(this.passwordInfo.confirmPassword === null || this.passwordInfo.confirmPassword !== this.passwordInfo.newPassword){
          this.passwordInfo.showConfirmTip = true
          return;
        }else {
          this.passwordInfo.showConfirmTip = false
        }
        let params = {
          oldPassword:this.passwordInfo.oldPassword,
          newPassword:this.passwordInfo.newPassword,
          confirmPassword:this.passwordInfo.confirmPassword
        }
        this.$post('/user/password/update',params).then(data => {
          if(data.errorCode === 0){
            //修改密码
            this.showPsPop = false;
            this.passwordInfo.oldPassword = null
            this.passwordInfo.newPassword = null
            this.passwordInfo.confirmPassword = null
            this.passwordInfo.showOldTip = false
            this.passwordInfo.showNewTip = false
            this.passwordInfo.showConfirmTip = false
          }
        })
      },
      // 更新当前用户信息
      updateCurrentUserInfo(){
        this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
        this.currentUserName = this.currentUser.realName;
        // if(this.currentUser.portraitUrl !== undefined && this.currentUser.portraitUrl !== ''){
        //   this.userImg = originconfig.domain + this.currentUser.portraitUrl;
        // }else {
        //   this.userImg = '../../static/assets/image/icon/header_img_man.png'
        // }
      },
      // 左侧菜单选择时
      handleSelect(key, keyPath) {
        this.activeIndex = key;
        this.$nextTick(function () {
          this.$router.push({name:key});
        })
      },
      // 退出登录
      getLogout() {
        MessageBox.confirm(
          '', '是否确认退出登录？', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
          this.$logout('/logout').then(data=>{
            if(data.errorCode == 0){
              sessionStorage.removeItem('currentUser');
              sessionStorage.removeItem('pushInfoList');
            }
          });
        }).catch(() => {

          }
        )
      },
      // 获取当前根路由
      showCurrentRootRoute() {
        let prs = parentRouteStack(this.$route.name, this.$router.options.routes);
        this.rootRoute = prs[prs.length - 2].name;
      },
      //  消息推送
      getMessage(m){
        if(m){
          let currRouter = this.$route.name;
          if(m.messageType == 1){
            if(currRouter !='customerRepair'){
              this.pushInfoList[0].count ++;
            }
          }else {
            if(currRouter !='customerMessage'){
              this.pushInfoList[1].count ++;
            }
          }
          sessionStorage.setItem('pushInfoList', JSON.stringify(this.pushInfoList));
        } else{
          //替换信息并显示“新消息”提示
          // this.$set(this.mQueue, item, m);
        }
      },
      handleTip(item){
        if(item.type === 'message'){
          this.$router.push({name:'customerMessage'})
        }else if(item.type === 'repair'){
          this.$router.push({name:'customerRepair'})
        }
      }
    },
  }
</script>

<style lang="scss">
  .main{
    .el-input.is-active .el-input__inner, .el-input__inner:focus {
      border-color: #f39800;
      outline: 0;
    }
    .tip{
      font-size: 12px;
      color: #f39800;
    }
  }
</style>
<style scoped lang="scss">
  .main{
    height: 100%;
    min-width: 1366px;
    .mainHeader{
      height:68px;
      background:#242424;
      display: flex;
      justify-content: space-between;
      padding-left: 24px;
      border-radius: 0px;
      position: relative;

      .mainHeaderLeft{
        height: 100%;
        display: flex;
        align-items: center;
        width: 344px;
        img{
          width: 104px;
          height: 22px;
        }
        span{
          margin-left: 10px;
          width:160px;
          height:20px;
          color:#fff;
          line-height:20px;
          font-weight:600;
          font-size:18px;
          white-space: nowrap;
        }
      }
      .minHeaderCenter{
        width: calc(100% - 654px);
        height: 100%;
        flex: 1;
        .topMenu{
          display: flex;
          justify-content: center;
          .el-menu{
            /*border-right:0px;*/
            /*background-color: transparent;*/
            background: none;
            height: 68px;
            border-right: none;
            text-align: center;
            .el-menu-item * {
               vertical-align: baseline;
            }
            .el-menu-item{
              padding-left: 25px!important;
            }
            .el-menu-item.is-active{
              span{
                font-weight: 600;
              }
            }
            .el-menu-item:focus{
              background-color: transparent;
            }
          }
          .el-menu-item, .el-submenu__title{
            /*height: 40px;*/
            /*line-height: 40px;*/
          }
          .el-menu-item:hover{
            background:transparent;
          }
        }
      }
      .minHeaderRight{
        width: 320px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .headerUserInfo{
          color: #fff;
          width: 132px;
          height: 24px;
          display: flex;
          align-items: center;
          img{
            width: 30px;
            height: 30px;
            border-radius: 50%;
            margin-right: 10px;
          }
        }
        .setOut{
          color: #fff;
          width: 108px;
          display: flex;
          height: 68px;
          padding-right: 24px;
          align-items: center;
          padding-left: 10px;
          cursor: pointer;
          &:hover{
            background-color: #FF6215;
            i{
              background: url("../assets/image/icon/title_icon_out_sel.png") no-repeat center;
            }
            /*p{*/
            /*  color:#fff;*/
            /*}*/
          }
          i{
            display: inline-block;
            width: 14px;
            height: 14px;
            margin: 0px 6px 0px 10px;
            background: url("../assets/image/icon/title_icon_out_nor.png") no-repeat center;
          }
        }
      }
    }
    .wrap {
      height: calc(100% - 68px);
      height: -moz-calc(100% - 68px);
      height: -webkit-calc(100% - 68px);
      background:#121212;
      display: flex;
      /*padding-top: 16px;*/
      .leftMenu{
        width:160px;
        height: calc(100% - 20px);
        height: -moz-calc(100% - 20px);
        height: -webkit-calc(100% - 20px);
        padding-top: 20px;
      }
      .rightContentScroll{
        width: 100%;
        height: calc(100% - 40px);
        height: -moz-calc(100% - 40px);
        height: -webkit-calc(100% - 40px);
        overflow: auto;
        padding: 16px 24px 24px 16px;
        /*padding: 0 24px;*/
        /*margin: 16px 0;*/
      }
      .rightContent{
        width: 100%;
        height: 100%;
      }
    }
    .pushInfoTipPop{
      position: fixed;
      right: 10px;
      bottom: 10px;
      .tipContent{
        width:201px;
        height:50px;
        border-radius:4px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 10px 0px;
        cursor: pointer;
        i{
          display: inline-block;
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }
      }
      .messageTipCon{
        background:rgba(237,245,255,1);
        box-shadow:0px 0px 4px 0px rgba(0,44,101,0.2);
        i{
          background: url("../assets/image/icon/news_icon_speak.png") no-repeat center;
        }
      }
      .repairTipCon{
        background:rgba(253,233,234,1);
        box-shadow:0px 0px 4px 0px rgba(123,0,0,0.2);
        i{
          background: url("../assets/image/icon/news_icon_repair.png") no-repeat center;
        }
      }
    }
    .noPermission {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/basalPage.vue